import React, { useState, useCallback, useMemo, useContext } from 'react';
import styled from 'styled-components';
import useLabels from '@ubeya/shared/hooks/account/useLabels';
import ConfigContext from '../../../contexts/ConfigContext';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import { TextWithTooltip } from '../../Tooltip';

const ShiftTypeFilterLabelText = styled(TextWithTooltip)`
  max-width: 200px;
`;

const ShiftTypeFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { labelOptions } = useLabels({ filterByBranch: true });
  const [values, setValues] = useState(defaultValue || []);

  const allOptions = useMemo(() => [{ value: -1, label: t('events') }, ...(labelOptions || [])], [labelOptions, t]);

  const filteredOptions = useMemo(
    () =>
      search
        ? allOptions.filter(
            ({ label }) =>
              t('shiftTypes').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : allOptions,
    [allOptions, search, t]
  );

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('shiftTypes')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox name={`shift-type-${value}`} value={values.includes(value)} onChange={() => handleChange(value)}>
            <ShiftTypeFilterLabelText>{label}</ShiftTypeFilterLabelText>
          </CheckBox>
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ShiftTypeFilter;
